import McHistogramChart from './McHistogramChart';

export default McHistogramChart;
